import { getFileAssociations, getFileOnlyImages, getFileImagesAndVideos } from './getFileAssociations'
import { addFile } from './addFile'
import { addImages } from './addImages'
import { deleteFile } from './deleteFile'
import { updateFileAssociationsOrder } from './updateFileAssociationsOrder'
import { deleteFileAssociationsByEntity } from './deleteFileAssociationsByEntity'
import { deleteFilesById } from './deleteFilesById'
import { bulkUploadFiles } from './bulkUploadFiles'
import { bulkInsertFileAssociations } from './bulkInsertFileAssociations'



export const Files = {
  getFileAssociations,
  getFileOnlyImages,
  getFileImagesAndVideos,
  addFile,
  deleteFile,
  addImages,
  updateFileAssociationsOrder,
  deleteFileAssociationsByEntity,
  deleteFilesById,
  bulkUploadFiles,
  bulkInsertFileAssociations
}
